import CargoCompanyDispatchDetailsRequest from "../../../../api/raily/cargo-company/dispatch/details/cargo-company-dispatch-details.request";
import CargoCompanyDispatchDetailsParams from "./cargo-company-dispatch-details-params";

const create = (
  params: CargoCompanyDispatchDetailsParams,
): CargoCompanyDispatchDetailsRequest => {
  return {
    cargoCompanyId: params.cargoCompanyUuid,
    dispatchId: params.dispatchUuid,
  };
};

const cargoCompanyDispatchDetailsParamsFactory = {
  create,
};

export default cargoCompanyDispatchDetailsParamsFactory;
